import { forwardRef, useImperativeHandle, useRef } from 'react'
import { SIDRender, SLowcodeList } from 'shj-components'
import config from './config'
import { Progress, Tag } from 'antd'
import { TabComponentInterface } from '../../../index.d'
import { getProjectList } from '@/services/pms'
import { useParams, useNavigate } from 'react-router-dom'
import { apiData2Table } from '@/utils/data'

const Project = forwardRef<TabComponentInterface>((_, ref) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const listRef = useRef<any>()

  const colors = {
    整家: 'magenta',
    整装: 'purple',
    软装: 'blue',
    零售: 'cyan',
    定制: 'cyan',
    局改: 'red',
  }

  // 暴露列表项隐藏弹窗的打开方法
  useImperativeHandle(ref, () => ({
    openSettingModal: () => {
      listRef.current?.openSetting?.()
    },
  }))

  // 获取项目列表
  const fetchList = (params: any) => {
    return new Promise((resolve, reject) => {
      try {
        getProjectList({
          params: {
            currentPage: params.current,
            pageSize: params.pageSize,
          },
          data: { customerId: id },
        }).then((res: any) => {
          resolve(apiData2Table(res))
        })
      } catch (error) {
        reject({ success: false })
      }
    })
  }

  const extension = {
    request: { fetchList },
    events: {},
    status: {},
    customRender: {
      // 项目ID渲染
      projectIdRender(_, record: Record<string, any>) {
        return (
          <SIDRender
            id={record.id}
            onClick={() => navigate(`/pms/projectPlus/projectDetail/${record.id}`)}
          />
        )
      },
      // 需求标签渲染
      demandTagRender(text: any) {
        return <Tag color={colors[text]}>{text}</Tag>
      },
      // 工期渲染
      timeLimitRender(text: any) {
        return text ? `${text}天` : '-'
      },
      // 项目进度渲染
      projectProgressRender(text: any) {
        // 将浮点数乘以100后四舍五入到整数，避免精度问题
        const percent = parseFloat((text * 100).toFixed(0))
        return <Progress percent={percent} size={'small'} />
      },
    },
  }

  return <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
})

export default Project
